import { motion } from "framer-motion";

export const EASE = [0.33, 1, 0.68, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);
